import { render, staticRenderFns } from "./SpecifiedCommercialTransactionsAct.vue?vue&type=template&id=276619d8"
import script from "./SpecifiedCommercialTransactionsAct.vue?vue&type=script&lang=ts"
export * from "./SpecifiedCommercialTransactionsAct.vue?vue&type=script&lang=ts"
import style0 from "./SpecifiedCommercialTransactionsAct.vue?vue&type=style&index=0&id=276619d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports